import Route from "@ember/routing/route";
import { service } from "@ember/service";
export default class GroupMessagesIndex extends Route {
  static #_ = (() => dt7948.g(this.prototype, "router", [service]))();
  #router = (() => (dt7948.i(this, "router"), void 0))();
  beforeModel() {
    this.router.transitionTo("group.messages.inbox");
  }
}